import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { AsyncPipe } from '@angular/common';

import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { AppType } from '@vendasta/marketplace-apps';
import { ActivationStatus, ProductActivation } from '@vendasta/sales-orders';
import { Observable } from 'rxjs';

import { FulfillmentRowComponent } from './fulfillment-row/fulfillment-row.component';
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { TranslateModule } from '@ngx-translate/core';
import { MatDivider } from '@angular/material/divider';
import {
  FulfillmentRowData,
  FulfillmentStatusService,
  MenuItemClickedInterface,
  MenuItemEventType,
} from './fulfillment-status.service';
import { map, take } from 'rxjs/operators';
import { FulfillmentOrder } from '@vendasta/order-fulfillment';
import { WorkOrderPersona } from '@vendasta/work-order';

@Component({
  selector: 'orders-fulfillment-status-card',
  templateUrl: './fulfillment-status-card.component.html',
  styleUrls: ['./fulfillment-status-card.component.scss'],
  providers: [FulfillmentStatusService],
  imports: [
    GalaxyAvatarModule,
    GalaxyBadgeModule,
    AsyncPipe,
    FulfillmentRowComponent,
    MatExpansionPanelTitle,
    TranslateModule,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatDivider,
  ],
})
export class FulfillmentStatusCardComponent implements OnInit, OnChanges {
  @Input() productActivations: ProductActivation[];
  @Input() workOrders: FulfillmentOrder[];
  @Input() partnerId: string;
  @Input() businessId: string;
  @Input() marketId: string;
  @Input() orderId: string;
  @Input() persona: WorkOrderPersona;

  @Output() workOrdersLinkClicked: EventEmitter<void> = new EventEmitter<void>();

  rows$: Observable<FulfillmentRowData[]>;
  shouldExpand$: Observable<boolean>;

  protected readonly ActivationStatus = ActivationStatus;
  protected readonly AppType = AppType;

  constructor(private fulfillmentStatusService: FulfillmentStatusService) {}

  ngOnInit() {
    this.rows$ = this.fulfillmentStatusService.getRows(
      this.productActivations,
      this.workOrders,
      this.partnerId,
      this.marketId,
    );

    this.shouldExpand$ = this.rows$.pipe(
      map((rows) => rows.some((row) => row.activationStatus === ActivationStatus.ERRORED)),
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.productActivations || changes.workOrders || changes.partnerId || changes.marketId) {
      this.rows$ = this.fulfillmentStatusService.getRows(
        this.productActivations,
        this.workOrders,
        this.partnerId,
        this.marketId,
      );
    }
  }

  menuItemClick(event: MenuItemClickedInterface): void {
    if (event.eventType === MenuItemEventType.IGNORE_ACTIVATION_ERRORS) {
      this.fulfillmentStatusService.ignoreErrors(this.orderId, this.businessId, event.value).pipe(take(1)).subscribe();
    }
  }

  handleWorkOrdersLinkClicked(): void {
    this.workOrdersLinkClicked.emit();
  }
}
